import { Typography } from "@mui/material";
import AuthorizationList from "./AuthorizationList";

export default function Authorization({ brandId }) {
  const web =
    brandId === "1" ? "https://bodytech.com.co" : "https://athleticgym.com.co";

  const dataTreatment =
    brandId === "1"
      ? "https://bodytech.com.co/terminos-y-condiciones"
      : "https://athleticgym.com.co/terminos-condiciones/politica-de-proteccion-de-datos";

  const dataTerminos =
    brandId === "1"
      ? "https://bodytech.com.co/terminos-y-condiciones" : "https://bodytech.com.co/terminos-y-condiciones";

  const label = brandId === "1" ? "BODYTECH" : "ATHLETIC";

  return (
    <Typography textAlign={"justify"}>
      EL AFILIADO otorga su consentimiento previo, expreso e informado
      al PRESTADOR  para tratar sus datos personales, que incluyen datos de
      carácter sensible como información médica,  de acuerdo con la Ley 1581 de 2012
      y las demás normas aplicables a la materia, y, según la Política de
      Tratamiento de Datos Personales disponible en:&nbsp;
      <Typography component={"span"} color={"primary"}>
        <a target="_blank" href={dataTerminos}>
          {dataTerminos}
        </a>
      </Typography> y&nbsp;
      <Typography component={"span"} color={"primary"}>
        <a target="_blank" href={dataTreatment}>
          {dataTreatment}
        </a>
      </Typography>, la cual EL AFILIADO declara conocer y aceptar.
      <br />
      <br />
      En particular, EL PRESTADOR  tratará los datos personales del AFILIADO
      para efectos de la prestación de sus servicios y en principalmente para las siguientes finalidades:
      <br />
      <br />
      
      <AuthorizationList/>

      Por otro lado, el Titular autoriza al  PRESTADOR para tratar sus datos semi privados de naturaleza financiera, crediticia y comercial,
      para reportarlo ante las centrales de riesgo en caso de incumplimiento de sus obligaciones pecuniarias de cara al PRESTADOR,
      así como, para consultar su información comercial, crediticia y financiera ante centrales de riesgo. Asimismo, el Titular
      autoriza al  PRESTADOR para tratar sus datos semi privados asociados a sus antecedentes penales, con el fin consultar aquella
      información que resulte relevante para el control y prevención del lavado de activos, en caso de que sea necesario.
      EL PRESTADOR podrá tratar los datos sensibles del EL AFILIADO, en especial aquellos relacionados con su salud con la
      finalidad de sugerir programas de entrenamiento, controlar avances y resultados, identificar riesgos por actividad física,
      así como contar con información suficiente en caso de urgencia médica y/o primeros auxilios, lo cual EL AFILIADO declara conocer
      y de manera expresa aceptar. Igualmente, EL PRESTADOR trata datos sensibles asociados a la identidad biométrica y realiza
      la videovigilancia de sus instalaciones, en el marco de lo cual puede tratar datos asociados a las características físicas
      y de imagen de EL AFILIADO, con el fin de contar con un esquema de seguridad que permita facilitar el acceso de los AFILIADOS,
      identificarlos plenamente a través de sistemas de video vigilancia y velar por la seguridad e integridad del entorno,
      los bienes y las personas en las instalaciones del PRESTADOR. En todo caso, el suministro de datos de naturaleza sensible se entenderá facultativo.
      <br />
      <br />
      EL AFILIADO tiene derecho a conocer, actualizar y rectificar sus datos personales, solicitar prueba de la autorización otorgada,
      ser informado sobre el uso que se ha dado a los datos, presentar quejas ante la SIC por infracción a la ley, solicitar la revocación
      de la autorización y/o la supresión de sus datos cuando no exista un deber legal o contractual de conservarlos; así mismo podrá acceder
      en forma gratuita a los mismos, a través de los canales arriba indicados.
      <br />
      <br />
      Nota: Si EL AFILIADO no desea autorizar al PRESTADOR para tratar su huella digital, en adelante deberá presentar su documento de identidad
      para ingresar a las sedes del PRESTADOR.
      <br />
      <br />
    </Typography>
  );
}
